export default __webpack_public_path__ + "static/media/plus.4a8cb517.svg";